export default __webpack_public_path__ + "ab23eb04c213f51aa267d40f9ea8dd5e.png";